
<!-- author kameshwar.d  date: 09-09-2025-->


<div class="mainContent">

  <div style="height: 12vh;">
    <div>
      <label i18n="@@wordTemplateTitle" class="textColour" [ngStyle]="{'border-color':buttonColor}">
        {{titleText}}
      </label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div>
    <div style="height: 25vh; padding-left: 0%; padding-right: 4%; margin-left: 10%">
      <form novalidate [formGroup]="FormWordTemplate">
        <div class="row">

          <!-- Word Template Upload -->
          <div class="col-lg-7">
            <div style="display: flex;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@chooseWordTemplate">Choose Word Template</mat-label>
                <input matInput type="text" maxlength="250" placeholder="Choose File"
                       formControlName="wordTemplateName" [(ngModel)]="statevaluechange.wordFileName" readonly>
              </mat-form-field>
              <div class="file-field" style="width: 20%;">
                <a class="btn-floating btn-sm m-0 float-right">
                  <em class="fas fa-paperclip mt-0" style="color:black"></em>
                  <input type="file" id="wordUpload" name="wordUpload"
                         (change)="wordFileChange($event)" formControlName="wordTemplateUpload">
                </a>
              </div>
            </div>
          </div>

          <!-- Excel Template Upload -->
          <div class="col-lg-7" style="margin-top: 1rem;">
            <div style="display: flex;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@chooseExcelTemplate">Choose Excel Template</mat-label>
                <input matInput type="text" maxlength="250" placeholder="Choose File"
                        [value]="excelFileName"readonly>
              </mat-form-field>
              <div class="file-field" style="width: 20%;">
                <a class="btn-floating btn-sm m-0 float-right">
                  <em class="fas fa-paperclip mt-0" style="color:black"></em>
                  <input type="file" id="excelUpload" name="excelUpload"
                         (change)="excelFileChange($event)" formControlName="excelTemplateUpload">
                </a>
              </div>
            </div>
          </div>

          <!-- Unified Upload Button
          <div class="col-lg-5" style="margin-top: 2rem;">
            <button type="button" (click)="uploadTemplates()"
                    [style.background-color]="buttonColor"
                    class="uploadfileButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
              Upload
              <em style="padding-left:10px;" class="fas fa-upload example-icon" title="Upload"></em>
            </button>
          </div> -->

        </div>
      </form>
    </div>
  </div>

  <!-- Footer Buttons -->
  <div style="height:3vh">
    <div class="row mb-1 topRowMargins" style="position:sticky;left:0;bottom:0;width:100%">
      <div class="col-lg-5"></div>
      <div class="col-lg-7" style="text-align: end; margin-left: 10%">
        <button i18n="@@TargetCancel" type="button" (click)="closeTemplate()"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="buttonColor">
          Cancel
        </button>
        <button i18n="@@regenerateWordButton" type="button" (click)="uploadTemplates()"
                [style.background-color]="buttonColor"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
          Upload
        </button>
      </div>
    </div>
  </div>

</div>
